import { createContext, useState, useEffect, useCallback } from 'react';
import { invoiceApiServices } from 'utils/axios';

// Create Context
export const PrivateKeyContext = createContext<any>(null);

const PrivateKeyProvider = ({ children }: any) => {
  const [privateKey, setPrivateKey] = useState(null);
  const [encryptionKey, setEncryptionKey] = useState(null);
  const [userRights, setUserRights] = useState('');
  const [isIOMDomain, setIsIOMDomain] = useState(false);
  const [instanceName, setInstanceName] = useState(false);

  // check Domain from io-market
  useEffect(() => {
    
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const subDomain = parts.length > 2 ? parts[parts.length - 2] : null;
    const isCheckCompany = subDomain?.toLowerCase().replace(/-/g, '').includes('iomarket') ?? false;

    if (isCheckCompany) {
      setIsIOMDomain(true);
      return;
    }
    setIsIOMDomain(false);
  }, [])

  const getConfigurations = useCallback(async () => {
    try {
      const hostname = window.location.hostname;
      const parts = hostname.split('.');
      const subDomain = parts.length > 2 ? parts[parts.length - 2] : null;
      const isCheckCompany = subDomain?.toLowerCase().replace(/-/g, '').includes('ionetgate') ?? false;

      if (isCheckCompany) {
        const response = await invoiceApiServices.get("/main/getMetadata");

        if (response.status === 200 && response.data.DATA) {
          const data = JSON.parse(atob(response.data.DATA));
          setPrivateKey(data.privateKey['key'] || {});
          setEncryptionKey(data.encryptionKey || "");
        }
        return null
      }
      return;
    } catch (err) {
      console.error("Error fetching metadata:", err);
    }
  }, [isIOMDomain]);

  useEffect(() => {
    getConfigurations();
  }, [getConfigurations]);

  // useEffect(() => {
  //   if (privateKey && encryptionKey && isIOMDomain) {
  //     getWhiteLabelConfig();
  //   }
  // }, [privateKey, encryptionKey,isIOMDomain]);


  return <PrivateKeyContext.Provider value={{ privateKey, encryptionKey, userRights, setUserRights ,isIOMDomain , instanceName, setInstanceName}}>{children}</PrivateKeyContext.Provider>;
};

export default PrivateKeyProvider;